import PropArray from "../type/propArray";
import useWarehouse from "../warehouse/useWarehouse";
import useChainCreator from "./chain/useChainCreator";

const useLayer = (defaultProps = {}) => {

    const { newLayer, discardChain, getOriginalSource } = useChainCreator();

    const rootLayers = newLayer(defaultProps, new PropArray());

    const injectProps = (props = {}, propertyPath = new PropArray()) => newLayer(props, propertyPath);

    const discardLayer = () => discardChain();

    const getRootLayer = () => rootLayers

    const getRootProps = () => getOriginalSources();

    return {
        injectProps,
        getRootLayer,
        discardLayer,
        getRootProps,
        getOriginalSource
    }
}

export default useLayer;
